import { NavLink, Outlet } from 'react-router-dom';
import { useStore } from '../lib/store';

const LINKS = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/timesheet', label: 'Timesheet' },
  { to: '/projects', label: 'Projects' },
  { to: '/share', label: 'Share' },
  { to: '/settings', label: 'Settings' },
];

export function AppShell() {
  const { settings, signOut } = useStore();

  return (
    <div className="min-h-screen bg-[var(--color-paper)]">
      <header className="sticky top-0 z-30 border-b border-[var(--color-line)] bg-[rgba(253,251,248,0.88)] backdrop-blur-md">
        <div className="mx-auto flex max-w-[76rem] flex-wrap items-center gap-x-5 gap-y-3 px-5 py-3">
          <div className="flex items-center gap-2.5">
            <span
              className="flex h-8 w-8 items-center justify-center rounded-[10px] font-display text-[15px] font-bold text-white"
              style={{ background: 'linear-gradient(135deg, var(--color-coral-500), var(--color-blue-600))' }}
              aria-hidden
            >
              T
            </span>
            <span className="font-display text-[17px] font-semibold">Timesheet</span>
          </div>

          <nav className="order-3 -mx-1 flex w-full gap-1 overflow-x-auto sm:order-2 sm:w-auto sm:overflow-visible">
            {LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  `rounded-[var(--radius-pill)] px-3.5 py-1.5 text-[13px] font-semibold whitespace-nowrap transition-colors ${
                    isActive
                      ? 'bg-[var(--color-blue-100)] text-[var(--color-blue-700)]'
                      : 'text-[var(--color-ink-soft)] hover:bg-[var(--color-paper-sunk)]'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="order-2 ml-auto flex items-center gap-3 sm:order-3">
            {settings.owner_name && (
              <span className="hidden text-[13px] text-[var(--color-ink-muted)] sm:inline">
                {settings.owner_name}
              </span>
            )}
            <button type="button" className="btn btn-ghost text-[12px]" onClick={() => void signOut()}>
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[76rem] px-5 py-7">
        <Outlet />
      </main>
    </div>
  );
}

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="text-[26px] leading-tight">{title}</h1>
        {subtitle && <p className="mt-1 text-[13px] text-[var(--color-ink-muted)]">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
